import classNames from "classnames";
import { CommonComponentProps } from "../../config";
import styles from "./checkList.module.scss";
import CheckIcon from "@icons/checkIcon.svg";

export const CheckList = (props: CheckListProps) => {
  const {
    list,
    options: {
      sizeDesktop,
      sizeMobile,
      sizeTablet,
      orderingDesktop,
      orderingMobile,
      orderingTablet,
    },
  } = props;

  return (
    <div
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
        styles[`${orderingMobile}Mobile`],
        styles[`${orderingTablet}Tablet`],
        styles[`${orderingDesktop}Desktop`],
      )}
    >
      {list?.map((item, index) => (
        <div key={index} className={styles.textContainer}>
          <CheckIcon className={styles.icon} />
          {item.text}
        </div>
      ))}
    </div>
  );
};

export interface CheckListProps extends CommonComponentProps {
  list: {
    text: string;
  }[];
}
